<script lang="ts">
	import { FeedItemStatus } from '$lib/types/FeedStatusTypes';
	import StatusLabel from '@atoms/StatusLabel.svelte';
	import { Breakpoints, statusToText } from '@tools';

	let {
		status,
		badge,
		transform,
		responsive = false,
		vertical = false
	}: {
		status?: FeedItemStatus;
		badge?: string | null;
		transform?: string;
		responsive?: boolean;
		vertical?: boolean;
	} = $props();

	const text = $derived(statusToText(status));
</script>

{#if (status !== undefined && status !== FeedItemStatus.NO_STATUS) || badge}
	<div class="EventLabels" style:transform class:absolute={transform !== undefined}>
		{#if badge && (!responsive || Breakpoints.md)}
			<StatusLabel content={badge} {vertical} />
		{/if}
		{#if status !== undefined && status !== FeedItemStatus.NO_STATUS}
			<StatusLabel
				content={text}
				{responsive}
				{vertical}
				variant={status === FeedItemStatus.CANCELLED || status === FeedItemStatus.HELD
					? 'danger'
					: 'warning'}
			/>
		{/if}
	</div>
{/if}

<style lang="scss">
	div {
		display: flex;
		flex-direction: column;

		&.absolute {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 4;
		}
	}
</style>
